import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";
import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/EventHelpers/EventHelpers";
import "core/classes/form.validator.class";
import Pikaday from "pikaday";

$.validator.addMethod(
  "searchdateformat",
  function(value, element) {
    return (
      this.optional(element) || /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/.test(value)
    );
  },
  "The date must be entered in the format DD-MM-YYYY"
);

class DatePicker extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.startYear = this.element.parents("form").attr("data-start-year");
    this.setOptions(options);
    var pickerLangObj = $("body").data("pickerLang");
    this.options.i18n = pickerLangObj;
    if (this.startYear) {
      this.options.minDate = new Date(this.startYear + "-01-01");
    }
    this.createDatePicker();
  }

  createDatePicker() {
    this.picker = new Pikaday(this.options);
  }
}

export { DatePicker };



// WEBPACK FOOTER //
// ./Javascript/core/classes/searchresults/search.date.picker.js